module.exports = __webpack_public_path__ + "img/clouds.ba01dc4c.jpg";